import styled from 'styled-components'

const Style = {
	OutterWrapper: styled.div`
		> div:first-child {
			margin-bottom: 10px;
		}
	`,
	Wrapper: styled.div`
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 24px;
		height: fit-content;
		${({$noSearchInput}) =>
			$noSearchInput &&
			`
            justify-content: flex-end;
        `}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			flex-direction: column;
			gap: 16px;
			height: auto;
		}
	`,

	ContainerSearch: styled.div`
		display: flex;
		gap: 8px;
		flex: 1 1 300px;
		min-width: 300px;
		align-items: stretch;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			min-width: 0;
			width: 100%;
			flex: 1 1 auto;
			height: 38px;
		}

		& > input {
			flex: 1 1 auto;
			width: 100%;
			min-width: 300px;
			${({theme}) => theme.font.extra_small};
			padding: 0 20px;
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				min-width: 0;
				height: 38px;
			}
		}
	`,

	ContainerSelect: styled.div`
		display: flex;
		flex-wrap: wrap;
		gap: 24px;
		align-items: center;
		width: auto;
		max-width: 100%;
		min-width: 0;
		flex: 0 1 auto;
		justify-content: flex-start;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			width: 100%;
			gap: 12px;
		}

		& > div {
			display: flex;
			gap: 8px;
			align-items: center;
			width: auto;
			flex: 0 0 auto;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				width: 100%;
				justify-content: space-between;
			}

			& > h2 {
				font-size: 16px;
				white-space: nowrap;
			}

			& > select {
				width: 160px;
				${({theme}) => theme.font.extra_small};
				padding: 8px 16px;
				border: 1px solid ${({theme}) => theme.color.grey3};
				border-radius: 4px;
				cursor: pointer;

				@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
					width: auto;
					min-width: 120px;
					flex: 1;
				}
			}
		}
	`,
}

export default Style